import { LargeVisionActionTypes } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import dwellTimelineGrouped, { DwellTimelineGroupedOutput } from '../../utils/dwellTimelineGrouped'
import type { Fixture as LargeVisionFixture } from '../types'

/**
 * Large Vision Dwell timeline reducer
 */
const largeVision = buildAsyncStatReducer({
    key: Metrics.LARGEVISION_DWELLTIMELINE,
    types: {
        request: LargeVisionActionTypes.DASHBOARD_LARGEVISION_DWELLTIMELINE.request,
        success: LargeVisionActionTypes.DASHBOARD_LARGEVISION_DWELLTIMELINE.success,
        failure: LargeVisionActionTypes.DASHBOARD_LARGEVISION_DWELLTIMELINE.failure,
    },
    transform: (state, { payload = {} }): DwellTimelineGroupedOutput => {
        return dwellTimelineGrouped<LargeVisionFixture>(payload)
    },
})

export default largeVision
